import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import Paginator from './../paginator/paginator';
import { getUserType, currentUserId, getUserTypes, getYesNoOptions, setConfig, getConfig, getYesNo, getLocalizedCountryFromCurrency } from './../../utils';
import ManagementTable from "./../tables/managementTable";
import { toast } from "react-toastify";
import { toJS } from "mobx";
import cloneDeep from 'lodash/cloneDeep';

const UsersAdmin = () => {

    const { usersAdminStore, utilsStore,loginStore } = useStores();
    const { getAllUsers, users, remove, duplicate, getAllWithOptions, } = usersAdminStore;
    const { getCurrencies, currencies } = utilsStore;
    const { changeSession } = loginStore;

    const { t, i18n } = useTranslation();
    
    const [isLoading, setIsLoading] = useState(false);
    
    const tableRef = useRef(null);
    let navigate = useNavigate();
    
    useEffect(() => {
        Promise.all([getCurrencies()]);
    },[]);

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);
        
        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {                
                if (f.field == "type") {                    
                    f.value = getTypes()?.find(x => x.text == f.value)?.value;
                }
            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }        

    const getTypes = () => {
        return getUserTypes().map(x => { return { text: x.key, value: x.id?.toString() } });        
    }
    const [show, setShow] = useState(false);
    const [modalSettings, setModalSettings] = useState({});

    const showDeleteModal = (title,body,id) => {
        setModalSettings({
            title:title, body: body, onConfirm: () =>
                remove(id).then(() => { tableRef?.current?.resetPage() })
        })
        setShow(true);
    }

    return (              
        <div>
        <ConfirmPopup show={show} isDeleting={modalSettings?.isDeleting || false} onClose={()=>setShow(false)} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />

        <ManagementTable
            name={t('users')} ref={tableRef} isLoading={isLoading}            
            onColumnSizeChange={(c) => setConfig("users", "size", c)}
            onDataStateChange={(c) => { setConfig("users", "dataState",c) }}
            onFiltersChange={(c) => {/* setConfig("filter", c) */}}
            config={{ size: getConfig("users", "size"), dataState: getConfig("users","dataState") }}


            extraButtons={[
                {
                    text: t('loginAs'), icon: solid("right-to-bracket"), onClick: (id) => {
                        //changeSession(id)
                        setModalSettings({ title: t("loginAs"), body: t("loginAsConfirmation"), onConfirm: () => changeSession(id) })
                        setShow(true);
                    }
                },
                { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) }},
                { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy")},
                {
                    text: t('delete'), icon: solid("trash"), onClick: async (id) => {
                        var user = users?.results?.find(x => x.id === id);
                        if (user) {
                            if (user?.type === 2 && user?.projects?.length > 0) {
                                showDeleteModal(t("delete"), t("ClientIsValidatorForProjects") + ":<br/><br/>" + user?.projects?.join("<br/>"), user.id);
                            }
                            else
                                showDeleteModal(t("delete"), t("confirmDelete"), user.id);
                        }                                                                
                    }, danger: true
                }
            ]}
            items={users?.results} onPageChange={onPageChange} pageCount={users?.pageCount} total={users?.count} pageSize={users?.pageSize}
            columns={
                [
                    { name: "type", fn: (v) => getUserType(v), variant: "select", filterSelectOptions: getTypes() },
                    { name: "username"},
                    { name: "name" },
                    { name: "surname" },                    
                    { name: "salary", prop: "salaryWinbiz", fn: (v) => t(v ? "yes" : "no"), filterSelectOptions: getYesNo()},
                    { name: "company", prop: "salaryCompany", fn: (v) => v?.name ?? "-" },
                    { name: "currency", prop: "salaryCurrency", fn: (v) => v?.shortName ? `${v.shortName} - ${getLocalizedCountryFromCurrency(v)}` : "-", filterSelectOptions: currencies?.map((x) => ({ value: x.id.toString(), text: `${x.shortName} - ${getLocalizedCountryFromCurrency(x)}` })) },
                    { name: "active", prop: "isActive", fn: (v) => t(v ? "yes" : "no"), filterSelectOptions: getYesNo() },
                    ]
                }/>
                </div>
              
               

    );
};

export default observer(UsersAdmin);
